import { FunctionComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle';
import { useTheme } from '../../hooks/use-theme/use-theme';
import classNames from 'classnames';

interface Props {
	title?: string;
	description?: string;
	profileUrl: string;
	className?: string;
	ariaHidden?: boolean;
}

// TODO: remove this with new API refactor
const validateImage = profileUrl => (profileUrl === '/images/avatar.png' ? null : profileUrl);

const Avatar: FunctionComponent<Props> = ({ title, description, profileUrl, className, ariaHidden }) => {
	const { primaryColor } = useTheme();
	const validatedProfileImage = validateImage(profileUrl);

	const avatarInfoARIALabel = `${title || ''} ${description || ''}`;

	return (
		<div className={classNames('avatar', className)} data-testid="avatar" aria-hidden={ariaHidden}>
			<div className="avatar-icon">
				{validatedProfileImage ? (
					<div
						className="avatar-custom-icon"
						data-testid="avatar-custom-icon"
						style={{ borderColor: primaryColor, backgroundImage: `url(${profileUrl})` }}
					/>
				) : (
					<FontAwesomeIcon icon={faUserCircle} style={{ color: primaryColor }} />
				)}
			</div>

			<div className="avatar-info" aria-label={avatarInfoARIALabel} tabIndex={0}>
				{title && (
					<div className="avatar-title" aria-hidden={true}>
						{title}
					</div>
				)}
				{description && (
					<div className="avatar-description" aria-hidden={true}>
						{description}
					</div>
				)}
			</div>
		</div>
	);
};

export default Avatar;
